module.exports = __webpack_public_path__ + "img/prize-02.bef2aee2.png";